import $ from 'jquery';
import highlightShare from 'highlight-share';
import * as twitterSharer from 'highlight-share/dist/sharers/twitter';
import * as facebookSharer from 'highlight-share/dist/sharers/facebook';
// LinkedInSharer disabled because it is not currently working.
// See: https://github.com/anythingcodes/highlight-share/issues/5

class Story {
    constructor() {
        this.initialize();
    }

    initialize() {
        const sharers = [twitterSharer, facebookSharer];
        const selectionShare = highlightShare({
            selector: '.block__wrapper',
            sharers,
        });

        // https://github.com/anythingcodes/highlight-share#mobile-devices
        if (!window.matchMedia || !window.matchMedia('(pointer: coarse)').matches) {
            selectionShare.init();
        }
    }

    static init() {
        if ($('.story').length > 0) {
            new Story();
        }
    }
}

export default Story;
